import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import { PlyrComponent } from "ngx-plyr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GlobalService } from "src/app/services/global.service";
import * as SecureLS from "secure-ls";
import { ActivatedRoute } from "@angular/router";
import Swal from "sweetalert2";
import { NgbTimeStruct } from "@ng-bootstrap/ng-bootstrap";
import CryptoJS from "crypto-js";
import { APP_CONFIG, IAppConfig, AppLogo1 } from "src/app/app.config";
import { StorageService } from "../../services/storage.service";
@Component({
  selector: "app-videocutplay",
  templateUrl: "./videocutplay.component.html",
  styleUrls: ["./videocutplay.component.css"],
})
export class VideocutplayComponent implements OnInit, AfterViewInit {
  @ViewChild(PlyrComponent) plyr: PlyrComponent;

  private ls = new SecureLS({ encodingType: "aes" });

  videosrc: any;
  player: Plyr;
  roleId: any;
  video_cut: FormGroup;
  play_point_cut: any = [];
  plsy_point_listing: any = [];
  submitted: boolean;
  total_time: any = 0;
  initTime: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
  seconds = true;
  spinners = false;
  preffessorName: string;
  subjectName: string;
  controlsList = "";
  isHLS = null;
  isSkipTimerOn: any = false;
  skipStartTime: any;
  skipEndTime: any;
  isPlayerReady: any = false;
  mediaPlayerEvent: any;
  rangeValues: number[] = [0, 100];
  appLogo = AppLogo1;
  showBookmarkList = false;
  videoListId: any;
  professorname: Object;
  professorData: any;
  assignForm: FormGroup;
  assignSubmitted: boolean = false;
  assignProfessor: any;
  professor_id: any;
  subjectData: any;
  subject: any;
  professorId: any;
  titleform: FormGroup;
  video_title: any;
  videoApproved: Object;
  video: any;
  professorid: any;
  transcriptionList: any;
  total_start_hr: any;
  total_end_hr: any;
  skipcheck: Object;
  skip_enable: boolean = false;
  getAllVideoDetails: Object;
  allVideoDetails: any;
  auto_edit: boolean = false;
  videourldata: any;

  constructor(
    private storageService: StorageService,
    private route: ActivatedRoute,
    public globalService: GlobalService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    public router: ActivatedRoute,
    private spinner: NgxSpinnerService,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  async ngOnInit() {
    this.roleId = this.storageService.getRole();
    this.preffessorName = this.ls.get("preffessorName");
    this.subjectName = this.ls.get("subjectName");
    this.video_cut = this.fb.group({
      start: [{ value: "", disabled: false }, [Validators.required]],
      end: [{ value: "", disabled: false }, [Validators.required]],
    });
    const decrypt = (data) => {
      return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    };
    if (this.router.snapshot.queryParams.isHls) {
      this.isHLS =
        decrypt(this.router.snapshot.queryParams.isHls) === "ZERO" ? 0 : 1;
    }

    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      id: this.router.snapshot.queryParams.key,
      resolution_type: "high",
    };

    if (this.isHLS == 0) {
      let video_url = await this.globalService.get(
        "classVideoDetail/get/video-url",
        filter
      );
      if (video_url["status"] == 200) {
        this.videosrc =
          video_url["content"].url +
          "?" +
          "token=" +
          video_url["content"].token +
          "&resolution_type=high&request_type=web";
      }    
    }
    this.updateVideoLog();
    setInterval(() => {
      this.updateVideoLog();
    }, 30000);
    this.assignForm = this.fb.group({
      sub_name: ["", [Validators.required]],
      profname: ["", [Validators.required]],
    });
    this.titleform = this.fb.group({
      title: ["", [Validators.required]],
    });
    this.getProfessor();
    this.getSubject();
    this.autoSkipConstraint();
  }

  onTimeStartChange() {
    if (
      this.forms.start.value?.hour ||
      this.forms.start.value?.minute ||
      this.forms.start.value?.second
    ) {
      let start_second = this.forms.start.value?.second;
      let start_min = this.forms.start.value?.minute * 60;
      let start_hrs = this.forms.start.value?.hour * 60 * 60;
      this.total_start_hr = start_second + start_min + start_hrs;
      this.mediaPlayerEvent.seekTime(this.total_start_hr);
    }
  }
  onTimeEndChange() {
    if (
      this.forms.end.value?.hour ||
      this.forms.end.value?.minute ||
      this.forms.end.value?.second
    ) {
      let end_second = this.forms.end.value?.second;
      let emd_min = this.forms.end.value?.minute * 60;
      let end_hrs = this.forms.end.value?.hour * 60 * 60;
      this.total_end_hr = end_second + emd_min + end_hrs;
      this.mediaPlayerEvent.seekTime(this.total_end_hr);
    }
  }
  get form2() {
    return this.assignForm.controls;
  }
  async onClickBookmark() {
    this.showBookmarkList = !this.showBookmarkList;
    this.isSkipTimerOn = false;
    this.video_cut.reset();
  }
  onLeftValue(data) {
    let cntrl = this.video_cut.controls;
    if (this.isSkipTimerOn) {
      let timeStr = new Date(Number(data.value) * 1000).toISOString();
      let time: NgbTimeStruct = {
        hour: Number(timeStr.substring(11, 13)),
        minute: Number(timeStr.substring(14, 16)),
        second: Number(timeStr.substring(17, 19)),
      };
      if (cntrl["end"].value === null) {
        cntrl["end"].patchValue(this.initTime);
      }
      cntrl["start"].patchValue(time);
      this.mediaPlayerEvent.seekTime(Number(data.value), false);
    }
  }

  onRightValue(data) {
    let cntrl = this.video_cut.controls;
    if (this.isSkipTimerOn) {
      let timeStr = new Date(Number(data.value) * 1000).toISOString();
      let time: NgbTimeStruct = {
        hour: Number(timeStr.substring(11, 13)),
        minute: Number(timeStr.substring(14, 16)),
        second: Number(timeStr.substring(17, 19)),
      };
      if (cntrl["start"].value === null) {
        cntrl["start"].patchValue(this.initTime);
      }
      cntrl["end"].patchValue(time);
      this.mediaPlayerEvent.seekTime(Number(data.value), false);
    }
  }

  async ngAfterViewInit() {
    const decrypt = (data) => {
      return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    };
    if (this.router.snapshot.queryParams.isHls) {
      this.isHLS =
        decrypt(this.router.snapshot.queryParams.isHls) === "ZERO" ? 0 : 1;
    }
    if (this.isHLS == 1) {
      let filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        resolution_type: "high",
      };
      let videourl = await this.globalService.get(
        "classVideoDetail/get/stream/video/details",
        { ...filter, video_id: this.router.snapshot.queryParams.key }
      );
      this.videourldata = videourl["content"];
      if (videourl["status"] == 200) {
        this.videosrc = `/live/nfs-share${videourl["content"].local_file_path}${videourl["content"].high_file_name}`;
      }
    }
  }

  onAssign(content) {
    if (this.ls.get("token")) {
      this.modalService.open(content, { scrollable: true });
    }
    this.getProfessor();
  }
  async getProfessor() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = this.professorname["content"];
    this.spinner.hide();
  }

  getProfessorName(professor) {
    return `${professor.first_name} (${professor.email_address})`;
  }

  async getSubject() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    this.subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = this.subject["content"];
    this.spinner.hide();
  }

  async onSubmit() {
    this.assignSubmitted = true;
    this.submitted = true;
    if (this.assignForm.invalid) {
      return;
    }
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      id: this.router.snapshot.queryParams.key,
      professor_id: this.assignForm.controls.profname.value,
      subject_id: this.assignForm.controls.sub_name.value,
    };
    this.assignProfessor = await this.globalService.update(
      "classVideoDetail/assign/professor",
      filter
    );
    if (this.assignProfessor["status"] === 200) {
      Swal.fire("", "Successfully assigned");
      location.href='/pending';
    } else if (this.assignProfessor["status"] === 400) {
      Swal.fire("", this.assignProfessor["error"].message, "error");
    }

    this.assignSubmitted = false;
    this.submitted = false;
    this.assignForm.reset();
    this.modalService.dismissAll();
    this.spinner.hide();
  }

  onPlayerReady(event) {
    this.mediaPlayerEvent = event;
    event.getDefaultMedia().subscriptions.loadedMetadata.subscribe(() => {
      this.filter_list();
      this.isPlayerReady = true;
      this.total_time = event.duration;
    });
    event.getDefaultMedia().subscriptions.timeUpdate.subscribe(($event) => {
      // if (this.isSkipTimerOn) {
      //   event.pause();
      // }
      if (Number(this.transcriptionList?.end) == event.currentTime) {
        event.pause();
      }
    });
  }
  onPlayerReadyPreview(event) {
    this.mediaPlayerEvent = event;
    event.getDefaultMedia().subscriptions.timeUpdate.subscribe(($event) => {
      this.playing(event);
    });
  }
  seekForward() {
    if (this.mediaPlayerEvent) {
      this.mediaPlayerEvent.currentTime += 10;  // Seek forward by 10 seconds
    }
  }
   
  seekBackward() {
    if (this.mediaPlayerEvent) {
      this.mediaPlayerEvent.currentTime -= 10;  // Seek backward by 10 seconds
    }
  } 


  onPlaybackReady() {
    //..
  }

  async updateVideoLog() {
    let inputDate: any;
    if (
      this.storageService.getRole() == 4 ||
      this.storageService.getRole() == 5
    ) {
      inputDate = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        role_id: this.storageService.getRole(),
        video_details_id: this.router.snapshot.queryParams.key,
        video_type: 2,
      };
      let video_log = await this.globalService.create(
        "videolog/student/video/log",
        inputDate
      );
    }
    
  }

  get forms() {
    return this.video_cut.controls;
  }

  addZeroPrefix(n): string {
    return (`${n}`.length == 1) ? `0${n}` : `${n}`
  }

  async filter_list() {
    this.spinner.show();
    let inputData = {
      vendor_id: this.ls.get("vendor_id"),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
      user_id: this.ls.get("createdBy"),
    };

    let filter_list = await this.globalService.get(
      "video/filter/list/filter",
      inputData, true
    );

    if (filter_list["status"] === 200) {
      this.play_point_cut = filter_list["content"];
      this.plsy_point_listing = [];

      let start;
      let end;
      for await (var duration_point of this.play_point_cut) {
        if (duration_point.filter_start < 3600) {
          var a = Math.floor(duration_point.filter_start / 60); //minutes
          var b = duration_point.filter_start % 60; //seconds

          start = this.addZeroPrefix(a) + ":" + this.addZeroPrefix(b);
        } else {
          var a = Math.floor(duration_point.filter_start / 3600); //hours
          var x = duration_point.filter_start % 3600;
          var b = Math.floor(x / 60); //minutes
          var c = duration_point.filter_start % 60; //seconds

          start = this.addZeroPrefix(a) + ":" + this.addZeroPrefix(b) + ":" + this.addZeroPrefix(c);
        }

        if (duration_point.filter_end < 3600) {
          var a = Math.floor(duration_point.filter_end / 60); //minutes
          var b = duration_point.filter_end % 60; //seconds

          end = this.addZeroPrefix(a) + ":" + this.addZeroPrefix(b);
        } else {
          var a = Math.floor(duration_point.filter_end / 3600); //hours
          var x = duration_point.filter_end % 3600;
          var b = Math.floor(x / 60); //minutes
          var c = duration_point.filter_end % 60; //seconds

          end = this.addZeroPrefix(a) + ":" + this.addZeroPrefix(b) + ":" + this.addZeroPrefix(c);
        }

        this.plsy_point_listing.push({
          id: duration_point.id,
          filter_start: start,
          filter_end: end,
        });
      }
    }
    else if(filter_list["status"] === 400){
      this.plsy_point_listing = [];
    }
    this.spinner.hide();
  }

  async playing(event) {
    for await (var duration_point of this.play_point_cut) {
      // Array of filter points
      if (
        event.currentTime >= duration_point.filter_start &&
        event.currentTime < duration_point.filter_end
      ) {
        let skip_point =
          parseFloat(duration_point.filter_end) -
          parseFloat(duration_point.filter_start);
        event.seekTime(skip_point, false);
        event.getDefaultMedia().currentTime = duration_point.filter_end;
        event.play();
      }
    }
  }

  onSkipTimerToogle() {
    this.skipStartTime = null;
    this.skipEndTime = null;
    this.video_cut.reset();
    this.isSkipTimerOn = !this.isSkipTimerOn;
    this.showBookmarkList = false;
  }
  async videoApprove(id) {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      id: this.router.snapshot.queryParams.key,
      is_video_approval: "1",
      video_title: this.video_title,
    };
    this.videoApproved = await this.globalService.update(
      "classVideoDetail/update-video-approval",
      filter
    );
    this.modalService.dismissAll();
    this.titleform.reset();
    this.video = this.videoApproved["content"];
    const decrypt = (data) => {
      return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    };
    if (this.router.snapshot.queryParams.isHls) {
      this.isHLS =
        decrypt(this.router.snapshot.queryParams.isHls) === "ZERO" ? 0 : 1;
    }
    if (this.isHLS == 1) {
      let filter = {
        user_id: this.ls.get("createdBy"),
        vendor_id: this.ls.get("vendor_id"),
        resolution_type: "high",
      };
      let videourl = await this.globalService.get(
        "classVideoDetail/get/stream/video/details",
        { ...filter, video_id: this.router.snapshot.queryParams.key }
      );
      if (videourl["status"] == 200) {
        this.videosrc = `/live/nfs-share${videourl["content"].local_file_path}${videourl["content"].high_file_name}`;
      }
    }
    this.spinner.hide();
  }
  videoTitle(form: FormGroup) {
    this.submitted = true;

    if (this.titleform.invalid) {
      return;
    } else {
      this.video_title = form.value.title;
      this.videoApprove(this.professor_id);
      Swal.fire("", "Successfully Approved");
      this.titleform.reset();
      this.submitted = false;
    }
  }
  openScrollableContent1(shortContent) {
    this.modalService.open(shortContent, { scrollable: true });
  }

  async secondsToMinutes(seconds) {
    if (seconds < 3600) {
      var a = Math.floor(seconds / 60); //minutes
      var b = seconds % 60; //seconds

      return a + ":" + b;
    } else {
      var a = Math.floor(seconds / 3600); //hours
      var x = seconds % 3600;
      var b = Math.floor(x / 60); //minutes
      var c = seconds % 60; //seconds

      return a + ":" + b + ":" + c;
    }
  }

  async delete(id) {
    this.spinner.show();
    let inputData = {
      vendor_id: this.ls.get("vendor_id"),
      id: id,
      user_id: this.ls.get("createdBy"),
    };

    await this.globalService.delete("video/filter/delete/filter", inputData);

    await this.filter_list();
      let data = {
        vendor_id: this.ls.get("vendor_id"),
        class_room_video_details_id: this.router.snapshot.queryParams.key,
        user_id: this.ls.get("createdBy"),
        auto_skip: 1
      };
      this.skipcheck = await this.globalService.get(
        "video/filter/list/filter",
        data, true
      );
      if(this.skipcheck["status"] === 400 || (this.skipcheck["status"] === 200 && this.skipcheck["content"].length == 1)){
        this.skip_enable = true;
      };
   
    this.spinner.hide();
  }

  onListClick(list): void {
    this.transcriptionList = list;
    this.mediaPlayerEvent.seekTime(Number(list.start), false);
    this.mediaPlayerEvent.play();
  }

  async addVideoPoint(form) {
    this.submitted = true;

    if (this.video_cut.invalid) {
      return;
    }

    let start_second = form.value.start.second;
    let start_min = form.value.start.minute * 60;
    let start_hrs = form.value.start.hour * 60 * 60;
    let end_second = form.value.end.second;
    let emd_min = form.value.end.minute * 60;
    let end_hrs = form.value.end.hour * 60 * 60;

    let total_start_hr = start_second + start_min + start_hrs;
    let total_end_ht = end_second + emd_min + end_hrs;

    // if (
    //   form.value.start.hour == "00" &&
    //   form.value.start.minute == "00" &&
    //   form.value.start.second == "00"
    // ) {
    //   Swal.fire("warning!", "Please Provide the Valid Start time", "warning");
    //   return false;
    // } else
    if (
      form.value.end.hour == "00" &&
      form.value.end.minute == "00" &&
      form.value.end.second == "00"
    ) {
      Swal.fire("warning!", "Please Provide the Valid End time", "warning");
      return false;
    }

    if (total_start_hr > this.total_time) {
      Swal.fire(
        "Alert!",
        "Start time must be less than video duration",
        "error"
      );
      return false;
    }

    if (total_end_ht > this.total_time) {
      Swal.fire("Alert!", "End time must be less than video duration", "error");
      return false;
    }

    if (total_start_hr > total_end_ht) {
      Swal.fire("Alert!", "Start time must be less than end time", "error");
      return false;
    }
    for await (var duration_point of this.play_point_cut) {
      if (
        duration_point.filter_start <= total_start_hr &&
        duration_point.filter_end >= total_start_hr
      ) {
        Swal.fire("Alert!", "Duplicate Entry not allowed", "error");

        return false;
      }
    }

    let inputData = {
      filter_start:
        total_start_hr !== 0 ? total_start_hr : total_start_hr.toString(),
      filter_end: total_end_ht,
      vendor_id: this.ls.get("vendor_id"),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
      user_id: this.ls.get("createdBy")
    };
    this.spinner.show();
    let content = await this.globalService.create(
      "video/filter/add/filter",
      inputData
    );
    if (content.status === 200) {
      this.video_cut.reset();
      this.skipStartTime = null;
      this.skipEndTime = null;
      this.isSkipTimerOn = false;
      await this.filter_list();
      this.spinner.hide();
    } else {
      this.spinner.hide();
    }
  }

  onPreview(content: any) {
    this.globalService.videoTranscription = false;
    this.modalService.open(content, { centered: true, size: "lg" });
  }

  async autoSkipConstraint() {
    let filter ={
      vendor_id: this.ls.get("vendor_id"),
      video_id: this.router.snapshot.queryParams.key,
      user_id: this.ls.get("createdBy"),
      requester_type:"web"
    }
    this.getAllVideoDetails = await this.globalService.get(
      "classVideoDetail/get/stream/video/details",
      filter
    );
    this.allVideoDetails = this.getAllVideoDetails["content"];
    if(this.allVideoDetails.audio_start_time > 0 || this.allVideoDetails.audio_end_time > 0 ){
      this.auto_edit = true;
    }
    let inputData = {
      vendor_id: this.ls.get("vendor_id"),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
      user_id: this.ls.get("createdBy"),
      auto_skip: 1
    };
    this.skipcheck = await this.globalService.get(
      "video/filter/list/filter",
      inputData, true
    );
    if(this.skipcheck["status"] === 400){
    if(this.allVideoDetails.audio_end_time > 0 || this.allVideoDetails.audio_start_time > 0)
    {
      this.skip_enable = true;
    }
  };
  }
  async autoSkipFilter() {
    let filter_start = this.allVideoDetails.audio_start_time > 0 ? this.allVideoDetails.audio_start_time: "0";
    let filter_end = this.allVideoDetails.audio_end_time > 0 ? this.allVideoDetails.audio_end_time : "0";
    let video_duration = this.allVideoDetails.video_duration;
    let inputData = {
      vendor_id: this.ls.get("vendor_id"),
      class_room_video_details_id: this.router.snapshot.queryParams.key,
      user_id: this.ls.get("createdBy"),
      audio_start_time: filter_start,
      audio_end_time: filter_end,
      video_duration: video_duration,
      auto_skip: 1,
      requester_type:"web"
    };
    let skipcheck = await this.globalService.create(
      "video/filter/add/skip/filter",
      inputData
    );
    await this.filter_list();
    this.skip_enable = false;
  }
}
